const Component = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 4C7.44772 4 7 4.44772 7 5V19C7 19.5523 7.44772 20 8 20C8.55228 20 9 19.5523 9 19V5C9 4.44772 8.55228 4 8 4Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 4C15.4477 4 15 4.44772 15 5V19C15 19.5523 15.4477 20 16 20C16.5523 20 17 19.5523 17 19V5C17 4.44772 16.5523 4 16 4Z"
        fill="white"
      />
    </svg>
  );
};

export default Component;
